// extracted by mini-css-extract-plugin
export default {"subHeader":"Buildings_subHeader__3xl-a"};